import React from 'react';
import * as styles from './index.module.scss';

import { LinkCard, Card } from './cards'

const CardContainer = ({ cards, blockIndex }) => {

    return(
        <div className={`${styles.col} ${styles.Three}`}>
            {
                cards && cards.cards.map((card, index) => {
                    if(card?.url) {
                        return(
                            <LinkCard
                                card={card}
                                key={`block-${blockIndex}-card-${index}`}
                            />
                        )
                    }else{
                        return(
                            <Card
                                card={card}
                                key={`block-${blockIndex}-card-${index}`}
                            />
                        )
                    }
                })
            }
        </div>
    )
}

export default CardContainer;